
import { jsonp, getScript } from './utils';


function invoke(option) {
	let { wechatDebugMode, callback }  = option; 

	let getSignInfo = new Promise((resolve, reject) => {
		jsonp('//m.huya.com/index.php?m=WechatJsApi&do=getSignature', (signInfo) => {
		    resolve(signInfo);
		});
	})
	let getWechatScript = new Promise((resolve, reject) => {
		if (window.wx) {
		    resolve(wx);
		} else {
		    if (window.seajs) {
		    	//针对 v.huya.com 引入seajs 方式
		        seajs.use('//hd.huya.com/wapWeixinShareJs/jweixin-1.0.0.js', (wx) => {
		            resolve(wx);
		        });
		    } else {
		        getScript('//a.msstatic.com/huya/hd/wapWeixinShareJs/jweixin-1.0.0.js', () => {
		            resolve(wx);
		        });
		    }
		}
	});
	Promise.all([getWechatScript, getSignInfo]).then((values) => {
		let wx = values[0], signInfo = values[1];
		let { appId , timestamp, nonceStr, signature } = signInfo;
	  	wx.config({
	  	    debug: wechatDebugMode,
	  	    appId, 
	  	    timestamp, 
	  	    nonceStr, 
	  	    signature, 
	  	    beta: true,
	  	    jsApiList: [
	  	    	'checkJsApi',
  	            'onMenuShareTimeline',
  	            'onMenuShareAppMessage',
  	            'onMenuShareQQ',
  	            'onMenuShareWeibo',
  	            'launchApplication',
  	            'onMenuShareQZone'
  	        ] 
	  	});
	  	wx.ready(function() {
	  		window.WeixinJSBridge && window.WeixinJSBridge.invoke ? callback(WeixinJSBridge, appId) : document.addEventListener("WeixinJSBridgeReady", function() { callback(WeixinJSBridge, appId) }, false)
	  	})
	});
}

export default {
	versionGreaterThan(version) {
	    let oldVersion = version || "6.5.16",
	        reg = /MicroMessenger\/((\d+)\.(\d+)\.(\d+))/i,
	        curVersion = navigator.userAgent.match(reg)[1];
	    let  versionToNum = function(e) {
	        for (var e = e.toString(), t = e.split("."), o = ["", "0", "00", "000", "0000"], i = o.reverse(), a = 0, r = t.length; r > a; a++) {
	            var u = t[a].length;
	            t[a] = i[u] + t[a]
	        }
	        var p = t.join("");
	        return p
	    };
	    return +versionToNum(curVersion) > +versionToNum(oldVersion);
	},
	openApp(option) {
		let { schema, openFailCallback, openCancelCallback, wechatDebugMode }  = option;
	    invoke({
	    	wechatDebugMode,
	    	callback: (JSBridge, appId) => {
	        JSBridge.invoke("launchApplication", {
	            appID: appId,
	            schemeUrl: schema,
	            parameter: schema,
	            extInfo: schema
	        }, (e) => {
							if (( e.err_msg.indexOf("launchApplication:fail") > -1 || e.err_msg.indexOf("system:access_denied") > -1 ) && openFailCallback ) {
								openFailCallback(e.err_msg);
							} else if (e.err_msg.indexOf("launchApplication:ok") > -1 && openCancelCallback) {
								openCancelCallback(e.err_msg);
							}
	        })
	    }
	    })
	},
};



// WEBPACK FOOTER //
// ./src/utils/wechatApi.js